import { useFormatMessage } from "../intl";
import {
  Children,
  Stack,
  TextChildren,
} from "@dbn/omnichannel-design-system-g4p";
import { pipe } from "fp-ts/function";
import { CloseIcon, SingleTickIcon } from "@g4p/react-styleguide-library";
import * as classes from "./PackagesSelection.css";
import { option } from "fp-ts";

type PackageFeatureVariant = "included" | "not-included";

export type PackageFeatureProps = {
  variant: PackageFeatureVariant;
  label: TextChildren;
  info: option.Option<Children>;
};

export const PackageFeature = ({
  variant,
  label,
  info,
}: PackageFeatureProps) => {
  const formatMessage = useFormatMessage();
  const foldVariant: <A>(match: {
    whenIncluded: () => A;
    whenNotIncluded: () => A;
  }) => (variant: PackageFeatureVariant) => A = match => variant => {
    switch (variant) {
      case "included":
        return match.whenIncluded();
      case "not-included":
        return match.whenNotIncluded();
    }
  };
  return (
    <Stack grow vAlignContent="top" units={2} style={{ paddingBottom: "10px" }}>
      {pipe(
        variant,
        foldVariant({
          whenIncluded: () => [
            <SingleTickIcon
              width={"16px"}
              height={"16px"}
              style={{ marginTop: "2px" }}
              className={classes.featureIcon["included"]}
              aria-label={formatMessage("package.icon_included.ariaLabel")}
            />,
            <span className={classes.featureLabel["included"]}>
              {label}
              &nbsp;
              {pipe(info, option.toNullable)}
            </span>,
          ],
          whenNotIncluded: () => [
            <CloseIcon
              width={"14px"}
              height={"14px"}
              style={{ marginTop: "4px" }}
              className={classes.featureIcon["not-included"]}
              aria-label={formatMessage("package.icon_not_included.ariaLabel")}
            />,
            <span className={classes.featureLabel["not-included"]}>
              {label}
              &nbsp;
              {pipe(info, option.toNullable)}
            </span>,
          ],
        })
      )}
    </Stack>
  );
};
